/** Demo publicitario: estado efímero en sessionStorage (nunca API/BD). */

export const DEMO_STORAGE_KEY = 'ecosistema_fit_demo_v5';

export function loadDemoState() {
  try {
    const raw = sessionStorage.getItem(DEMO_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || parsed.version !== 5) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveDemoState(state) {
  try {
    sessionStorage.setItem(DEMO_STORAGE_KEY, JSON.stringify(state));
  } catch {
    /* quota / private mode */
  }
}

export function clearDemoState() {
  try {
    sessionStorage.removeItem(DEMO_STORAGE_KEY);
    sessionStorage.removeItem('ecosistema_fit_demo_v1');
    sessionStorage.removeItem('ecosistema_fit_demo_v2');
    sessionStorage.removeItem('ecosistema_fit_demo_v3');
    sessionStorage.removeItem('ecosistema_fit_demo_v4');
  } catch {
    /* ignore */
  }
}

export function todayYmd() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function shiftYmd(ymd, deltaDays) {
  const d = new Date(`${ymd}T12:00:00`);
  d.setDate(d.getDate() + deltaDays);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function uid(prefix = 'id') {
  return `${prefix}_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 7)}`;
}
